// src/components/CAForm.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FormPdfPreview from './formpdfpreview';

const CAForm = ({ clientId, onClose }) => {
  const [pdfSrc, setPdfSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL = 'https://alcobrakeadmin.com/v3';

  const fetchPdf = async (id) => {
    if (!id) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const response = await axios.get(
        `${API_BASE_URL}/v2/reports/downloadcapdf?clientId=${id}`,
        { responseType: 'blob' }
      );
      
      if (response.status === 200) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        setPdfSrc(url);
      } else {
        setError('Failed to load PDF');
      }
    } catch (err) {
      console.error('PDF fetch error:', err);
      setError('Error loading PDF. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (clientId?.id) {
      fetchPdf(clientId.id);
    } else if (clientId) {
      fetchPdf(clientId);
    }
    
    return () => {
      if (pdfSrc) {
        URL.revokeObjectURL(pdfSrc);
      }
    };
  }, [clientId]);

  const handleClose = () => {
    if (pdfSrc) {
      URL.revokeObjectURL(pdfSrc);
    }
    // Call the onClose callback
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="ca-form-container">
      <div className="ca-form-header">
        <h3>California 920 Form</h3>
        <button className="close-btn" onClick={handleClose}>✕</button>
      </div>
      
      <div className="ca-form-content">
        {loading ? (
          <div className="ca-form-loading">
            <div className="loader"></div>
            <span>Loading PDF... Please wait</span>
          </div>
        ) : error ? (
          <div className="ca-form-error">
            <p>{error}</p>
            <button className="btn-primary" onClick={() => fetchPdf(clientId?.id || clientId)}>
              Retry
            </button>
          </div>
        ) : pdfSrc ? (
          <FormPdfPreview src={pdfSrc} title="California 920 Form" />
        ) : (
          <div className="ca-form-empty">
            <p>No PDF available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CAForm;